import SubscribeMixin from './SubscribeMixin';

export default {
    mixins: [SubscribeMixin],
    data() {
        return {}
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth
        },
    },
    methods: {
        search() {
            this.updateRoute()
        },
        getRoute() {
            return {
                from: this.searchForm.airportFrom ? this.searchForm.airportFrom.id : null,
                to: this.searchForm.airportTo ? this.searchForm.airportTo.id : null,
                range: this.searchForm.dateRange,
                // rangeFrom: this.searchForm.dateRange ? this.searchForm.dateRange[0] : null,
                // rangeTo: this.searchForm.dateRange ? this.searchForm.dateRange[1] : null,
                // email: this.email,
                // phone: this.phone,
            }
        }
    }
}